/** @jsx jsx */
import { jsx } from '@emotion/react'
import React from 'react';
import { useData } from '../Data';

export function InsertHTML({ model, field = 'description_$lang' }: any) {
  const { lang } = useData();
  return (<div dangerouslySetInnerHTML={{ __html: model[field.replace('$lang', lang)] }}></div>);
}
